export * from './simple-layout.component';



// WEBPACK FOOTER //
// /var/www/backend/src/app/core/containers/simple-layout/index.ts